'use strict'

module.exports = (function () {
    /**
    * @ngdoc method
    * @name phoneLocalizer
    * @description Localizes phone numbers site wide
    **/

    var configurePhoneNumbers = function () {
        var $phoneOverrideEl = $('meta[name="phone-number-override"]');
        var $phoneNumberTextEls = $('[data-phone-number-text]');
        var $phoneNumberHrefEls = $('[data-phone-number-link]');
        if ($phoneOverrideEl.length > 0 && $phoneOverrideEl.attr('content')) {
            var phoneNumberOverride = $phoneOverrideEl.attr('content');

            $phoneNumberTextEls.text(phoneNumberOverride);
            $phoneNumberHrefEls.attr('href', 'tel:' + phoneNumberOverride.replace(/-/g, ''));
        } else {
            $phoneNumberTextEls.each(function (idx, phoneEl) {
                localizePhoneNumber($(phoneEl));
            });
            $phoneNumberHrefEls.each(function (idx, phoneHrefEl) {
                localizePhoneNumber($(phoneHrefEl));
            });
        }
    }

    // Get the cookie.
    // If the cookie doesn’t exist, get the query string.
    // Set the cookie for one day. 
    // return the default phone number.
    function localizePhoneNumber($phoneNumberEl) {
        var isTelAttrEl = $phoneNumberEl[0].hasAttribute('data-phone-number-link');

        var originCookie = $.cookie('GETOrigin');

        var localToPhoneDict = {};
        localToPhoneDict['AARP'] = '1-866-847-3858';
        localToPhoneDict['TZ'] = '1-800-889-7404';
        localToPhoneDict['MGYB'] = '1-888-522-3950';
        if ($phoneNumberEl.is("a")) {
            var ch = $phoneNumberEl.children();
            if (ch.count < 1) {
                localToPhoneDict['DEFAULT'] = ch[1] || "1-877-622-9109";
            } else {
                localToPhoneDict['DEFAULT'] = "1-877-622-9109";
            }

        } else {
            localToPhoneDict['DEFAULT'] = $phoneNumberEl.text() || "1-877-622-9109";
        }

        if (!originCookie) {
            if (isTelAttrEl) {
                if (typeof localToPhoneDict['DEFAULT'] === "object") {
                    $phoneNumberEl.attr('href', 'tel:' + localToPhoneDict['DEFAULT'].innerHTML.replace(/-/g, ''));
                } else {
                    $phoneNumberEl.attr('href', 'tel:' + localToPhoneDict['DEFAULT'].replace(/-/g, ''));
                }

            } else {
                $phoneNumberEl.text(localToPhoneDict['DEFAULT']);
            }

            return;
        }

        var cookieValue = originCookie.split('=')[1];

        if (cookieValue && localToPhoneDict['AARP']) {
            if (cookieValue.indexOf('AARP') > -1) {
                if (isTelAttrEl) {
                    $phoneNumberEl.attr('href', 'tel:' + localToPhoneDict['AARP'].replace(/-/g, ''));
                } else {
                    $phoneNumberEl.text(localToPhoneDict['AARP']);
                }
                return;
            }
        }

        if (cookieValue && localToPhoneDict['TZ']) {
            if (cookieValue.indexOf('TZ') == 0) {
                if (isTelAttrEl) {
                    $phoneNumberEl.attr('href', 'tel:' + localToPhoneDict['TZ'].replace(/-/g, ''));
                } else {
                    $phoneNumberEl.text(localToPhoneDict['TZ']);
                }

                return;
            }
        }

        if (cookieValue) {
            switch (cookieValue.charAt(0)) {
                case 'M':
                case 'G':
                case 'Y':
                case 'B':
                    if (isTelAttrEl) {
                        $phoneNumberEl.attr('href', 'tel:' + localToPhoneDict['MGYB'].replace(/-/g, ''));
                    } else {
                        $phoneNumberEl.text(localToPhoneDict['MGYB']);
                    }
                    return;
            }
        }

        if (isTelAttrEl) {
            $phoneNumberEl.attr('href', 'tel:' + localToPhoneDict['DEFAULT'].replace(/-/g, ''));
        } else {
            $phoneNumberEl.text(localToPhoneDict['DEFAULT']);
        }
    }

    // Return an object exposing the public items
    return {
        applyLocalization: configurePhoneNumbers
    };
}())